
<div [id]="'chart-container'+id" [ngStyle]="{ height: popUp ? '28em' : height }">

</div>

<script src="https://code.highcharts.com/modules/pattern-fill.js"></script>
<script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
